<template>
  <div v-if="readable" v-on:click="showSelector"  :class="`input ${editable ? '' : 'disabled'} ${viewdata}`" v-click-outside="closeOutside">
    <label v-if="viewdata == 'full'">{{fielddata.label}}</label>
    <div>
      <p v-if="itemdata.length == 1 && itemdata[0].category">
				<span v-for="label in labeltree">{{label}}</span>
			</p>
      <p v-else-if="itemdata.length > 1">[Batched]</p>
      <p v-else>-</p>
      <treeselect
        v-if="show"
        v-on:search-change="onSearch"
        v-on:select="onSelect"
        :always-open="true"
        :auto-load-root-options="false"
        :options="options"
        :disable-branch-nodes="true"
        :load-options="loadOptions"
				:disabled="!editable"
				/>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import {Treeselect, ASYNC_SEARCH, LOAD_CHILDREN_OPTIONS, LOAD_ROOT_OPTIONS} from '@riophae/vue-treeselect';
import Data from '../../main';
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
export default {
	name: 'Category',
	props: {
		item: Array,
		field: Object,
		view: String,
	},
	watch: {
		item: function() {
			this.itemdata = this.item;
			if(this.item[0]){
				this.labeltree = [];
				this.categoryTreeCollect(this.item[0].category);
			}
		},
	},
	data() {
		return {
			itemdata: this.item,
			fielddata: this.field,
			viewdata: this.view,
			options: null,
			show: false,
			editable: Data.fieldWriteable(this.field.id, Data),
			readable: Data.fieldReadable(this.field.id, Data),
			labeltree: []
		};
	},

	mounted: function() {
		if(this.item[0]){
			this.labeltree = [];
			this.categoryTreeCollect(this.item[0].category);
		}
	},

	methods: {
		categoryTreeCollect: function(o){
			if(o){
				this.labeltree.push(o.label);
				if( o.parent_recursive )
					return this.categoryTreeCollect( o.parent_recursive );
			}
		},

		closeOutside: function(event) {
			this.show = false;
		},

		showSelector: function() {
			this.show = true;
		},

		onSelect: function( e ) {
			if (this.viewdata == 'full') {
			//	this.itemdata[0].category = e;
				this.show = false;
				this.labeltree = [];
				this.categoryTreeCollect(e);

				return this.$emit('saveTrigger', {
					name: this.field.name,
					value: e.id,
					label: e.label,
					model: this.field.model
				});

			}

			this.$Progress.start();

			this.$axios
				.put('/item', {
					batch: [this.itemdata[0].id],
					update: {[this.field.name]: e.id},
				})
				.then((response) => {

					this.itemdata[0].category = e;
					this.labeltree = [];
					this.categoryTreeCollect(response.data.item.category);

				})
				.catch((error) => {
					console.log(error);
				})
				.finally(()=>{
					this.$Progress.finish();
					this.show = false;
				});
		},

		onSearch: function(searchQuery) {
			if (searchQuery.length < 4) return;
			this.$axios
				.get('/category/search/'+searchQuery, {
				})
				.then((response) => {
					this.options = response.data;
					return;
					// callback(null, response.data)
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(()=>{
					this.$Progress.finish();
				});
		},

		loadOptions: function({action, parentNode, callback, searchQuery}) {
			if (action == LOAD_CHILDREN_OPTIONS) {
				this.$axios
					.get('/category/children/'+parentNode.id, {
					})
					.then((response) => {
						parentNode.children = response.data;
						callback();
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(()=>{
						this.$Progress.finish();
					});
			}

			if (action == LOAD_ROOT_OPTIONS) {
				this.$axios
					.get('/category/children/0', {
					})
					.then((response) => {
						this.options = response.data;
						callback();
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(()=>{
						this.$Progress.finish();
					});
			}


			if (action == ASYNC_SEARCH) {
				if (searchQuery.length < 4) return;
				this.$axios
					.get('/category/search/'+searchQuery, {
					})
					.then((response) => {
						// console.log(response);
						// this.options = response.data;
						callback(null, response.data);
					})
					.catch((error) => {
						console.log(error);
					})
					.finally(()=>{
						this.$Progress.finish();
					});
			}
		},
	},
	components: {
		Treeselect,
	},
};

</script>

<style scoped lang="less">
span{
	display:block;

	&:before{
		content:"\2022 ";
	}
	&:not(:first-of-type):before{
		content:"\00BB ";
	}
}

.input > div{
  padding:4px;
  position: relative;
  cursor: pointer;
  height: 100%;
}
.vue-treeselect{
  position: absolute;
  top:4px;
  width: 400px;
  z-index: 10;
}


.full > div{
  border: 1px solid #efefef;
  margin-bottom: 20px;
}
.input > div > p{
  margin: 0;
}
.full > div > p{
  color: grey;
}
</style>

<style>
.vue-treeselect__option{
  border-collapse: separate !important;
}
</style>
